module.exports = __webpack_public_path__ + "static/media/medium.a5bd1b6a.svg";